/*
 *   File : success.js
 *   Author : https://evoqins.com
 *   Description :success modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react'

// Custom components
import { SecondaryButton } from '../Buttons';

const SuccessModal = (props) => {

    const [createStatus, setCreateStatus] = useState(false);

    useEffect(() => {
        var edit_modal = document.getElementById("success-modal");
        edit_modal.addEventListener("hidden.bs.modal", () => {
            setCreateStatus(false);
        });
    }, []);

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("success-modal-close");
        button.click();
        setCreateStatus(false);
        props.handleClose();
    };
    return (
        <div className="modal fade" id="success-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered ">
                <div className="modal-content e-border-radius-28 w-500px mx-auto ">
                    <img src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className='d-none'
                        id='success-modal-close'
                        alt='close'
                        data-bs-dismiss="modal" />
                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">

                        <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
                            Success!
                        </h4>
                        <img src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt='close'
                            className='cursor-pointer'
                            onClick={_handleCloseModal} />
                        {!createStatus &&

                            <img src={require("../../Assets/Images/Home/close.svg").default}
                                draggable={false}
                                className='d-none'
                                id='success-modal-close'
                                alt='close'
                                data-bs-dismiss="modal"
                                onPress={_handleCloseModal} />
                        }
                    </div>
                    <div className="modal-body px-4 pb-2 pt-0">
                        <p className='e-primary-font e-font-weight-400 e-font-16'>A new corridor has been created and saved.</p>
                        <div className='row pt-2 mt-4 pb-3'>
                            <div className='col text-end'>
                                <SecondaryButton name="Ok"
                                    className="w-25"
                                    onPress={_handleCloseModal} />
                            </div>                           
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

SuccessModal.defaultProps = {
    handleClose: () => { }
}


export default memo(SuccessModal);